const fromdataedit = [
  {
    inputdata: "",
    title: "仓库编号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "不填则保存后系统生成",
    types: "text",
    inputtype: "input",
    width: "210px",
    disabled: false,
    // lablewith: '90px',
  },
  {
    inputdata: "",
    title: "仓库名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
    // lablewith: '90px',
  },
  {
    inputdata: "",
    title: "仓库缩写",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
    // lablewith: '90px',
  },
  {
    inputdata: "",
    title: "省份",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "province",
    width: "220px",
    btx: true,
    // lablewith: '90px',
    options: [],
  },
  {
    inputdata: "",
    title: "城市",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "city",
    width: "220px",
    btx: true,
    // lablewith: '90px',
    options: [],
  },
  {
    inputdata: "",
    title: "区县",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "area",
    width: "220px",
    btx: true,
    // lablewith: '90px',
    options: [],
  },
  {
    inputdata: "",
    title: "地址",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "840px",
    // lablewith: '90px',
  },
  {
    inputdata: "",
    title: "联系人",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
    // lablewith: '90px',
  },
  {
    inputdata: "",
    title: "联系电话",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
    // lablewith: '90px',
  },
  {
    inputdata: "",
    title: "是否寄售",
    fontSize: "14px",
    color: "#333333",
    placeholder: "",
    types: "text",
    inputtype: "radio",
    width: "210px",
    radiotitle1: "是",
    radiotitle2: "否",
    // lablewith: '90px'
  },
  {
    inputdata: "",
    title: "归属仓库",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "select",
    width: "220px",
    btx: false,
    // lablewith: '90px',
    options: [
      {
        key: "平台",
        value: "平台",
      },
      {
        key: "经销商",
        value: "经销商",
      },
    ],
    event: "gsChageupdate",
  },
  {
    inputdata: "",
    title: "平台",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "selectautocomplete",
    width: "220px",
    btx: true,
    options: [],
  },
  {
    inputdata: "",
    title: "经销商",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "selectautocompletetow",
    width: "210px",
    autocomplete: "on",
    // lablewith: '90px',
    icon: false,
    options: [],
  },
];
export default fromdataedit;
